module.exports = __webpack_public_path__ + "img/2.dccec589.png";